<p-autoComplete #autocomplete [suggestions]="filteredStaffInfos" [placeholder]="placeholder"
  field="displayText" [readonly]="readonly" [appendTo]="appendTo" [minLength]="2" [panelStyleClass]="panelStyleClass"
  (onSelect)="onAutoCompleteSelect($event)" (completeMethod)="filterData($event)" (onBlur)="onAutoCompleteBlur($event)">
</p-autoComplete>
